@if ({thuisverzorger: thuisverzorger$ | async, zones: zones$ | async, diensten: diensten$ | async}; as data) {
  @if (data.thuisverzorger && data.diensten && data.zones) {
    <zah-upsert-thuisverzorger
      [thuisverzorger]="data.thuisverzorger"
      [zones]="data.zones"
      [diensten]="data.diensten"
      okLabel="Bewaar"
      (cancelClicked)="onCancelClicked()"
      (okClicked)="onEditClicked($event)">
    </zah-upsert-thuisverzorger>
  }
}

